import Vue from "vue";
import store from "@continente/vue/components/store";
import VueSlickCarousel from "vue-slick-carousel";
import { mapGetters } from "vuex";
import {
    DeliveryScheduleDateItem,
    DeliveryScheduleIntervalList,
    DeliveryScheduleSummary,
    DeliveryNonScheduledSummary
} from "./deliverySchedule/deliveryScheduleGeneral";
import { initVueDeliverySchedule } from "../../../js/checkout/components/deliverySchedule";
import { editStepHandler } from "../../../js/checkout/stepsCT";

const SLICK_LIMIT_LARGE = 7;
const SLICK_LIMIT_MEDIUM = 6;
const SLICK_LIMIT_SMALL = 4;

const DeliveryScheduleComponent = Vue.extend({
    template:/* html */ `
        <div class="w-100" v-if="shipmentDeliverySlots">
            <div class="step-body--selection js-step-body-selection">
                <div
                    class="delivery-schedule-wrapper delivery-schedule-form"
                    id="delivery-schedule-form"
                    name="delivery-schedule-form"
                >
                    <div
                        v-if="shipmentDeliverySlots.groupedDeliverySlots"
                        :class="['row delivery-schedule-date col-12 col-sm-12 p-0 mx-0', shipmentDeliverySlots.isNonScheduled ? 'non-scheduled-delivery' : '']"
                        :data-dates-less-large="shipmentDeliverySlots.groupedDeliverySlots.length <= ${SLICK_LIMIT_LARGE}"
                        :data-dates-less-medium="shipmentDeliverySlots.groupedDeliverySlots.length <= ${SLICK_LIMIT_MEDIUM}"
                        :data-dates-less-small="shipmentDeliverySlots.groupedDeliverySlots.length < ${SLICK_LIMIT_SMALL}"
                    >
                        <VueSlickCarousel :arrows="!shipmentDeliverySlots.isNonScheduled" :draggable="!shipmentDeliverySlots.isNonScheduled" v-bind="settings" @beforeChange="handleBeforeSlide" ref="slick">
                            <template #prevArrow="arrowOption">
                                <div class="custom-arrow">
                                    <span v-html="prevArrow" />
                                </div>
                            </template>
                            <delivery-schedule-date-item
                                v-for="(deliverySlot, index) in shipmentDeliverySlots.groupedDeliverySlots"
                                :value="shipmentDeliverySlots.isNonScheduled ? deliverySlot.deliveryTypeDescription : (deliverySlot.slotDateDayName + ' - ' + deliverySlot.slotDateDay + ' - ' + deliverySlot.slotDateMonth)"
                                :non-scheduled-interval="shipmentDeliverySlots.isNonScheduled ? '(' + deliverySlot.formattedStart + ' - ' + deliverySlot.formattedEnd + ')' : ''"
                                :index="index"
                                :key="index"
                                :delivery-slot="deliverySlot"
                                :is-non-scheduled="shipmentDeliverySlots.isNonScheduled"
                                :auto-select-slot="shipmentDeliverySlots.autoSelectSlot"
                                :shipping-id="shipmentDeliverySlots.shipmentId"
                                :data-intervals-scheduler-ids="getSchedulerIdsForDateItem(deliverySlot)"
                                :delivery-slots-length="shipmentDeliverySlots.groupedDeliverySlots.length"
                                :checkmark-icon="checkmarkIcon"
                            />
                            <template #nextArrow="arrowOption">
                                <div class="custom-arrow">
                                    <span v-html="nextArrow" />
                                </div>
                            </template>
                        </VueSlickCarousel>
                        <span v-html="getFormattedDescription" class="non-scheduled-delivery-description d-flex" v-if="shipmentDeliverySlots.isNonScheduled"></span>
                        <span class="has-shipping-coupon-message" v-if="hasShippingCoupon">{{ resources.hasShippingCouponMessage }}</span>
                    </div>
                    <delivery-schedule-interval-list
                        :delivery-slots="shipmentDeliverySlots.groupedDeliverySlots"
                        :shipping-id="shipmentDeliverySlots.shipmentId"
                        :resources="resources"
                        :checkmark-icon="checkmarkIcon"
                        :arrow-up-down="arrowUpDown"
                    />
                </div>
            </div>
        </div>
    `,
    computed: {
        ...mapGetters(["getShipmentData"]),
        getFormattedDescription() {
            return this.informationIcon + "<div>" + this.shipmentDeliverySlots.slotDetailsDescription + "</div" ;
        }
    },
    mounted() {
        this.getPreviouslyBookedDay();
        this.selectDefaultDay();
        Vue.nextTick().then(() => {
            this.addCustomClassToSlickList();
        });
    },
    data: () => {
        return {
            loadingMoreSlots: false
        };
    },
    created() {
        if (this.shipmentDeliverySlots.isNonScheduled) {
            const stepHeaderTitle = document.querySelector(`.step-type--schedule[data-shipment-id="${this.shipmentDeliverySlots.shipmentId}"] .step-header--title`);
            if (stepHeaderTitle) {
                stepHeaderTitle.innerText = this.shipmentDeliverySlots.shippingHeaderTitle;
            }
        }
    },
    methods: {
        addCustomClassToSlickList() {
            this.$refs.slick.$el.querySelector(".slick-list")?.classList.add("delivery-slots-container");
        },
        getMoreShippingDays() {
            return new Promise((resolve, reject) => {
                const shipmentId = this.shipmentID;
                const deliverySlots = $(`.shipping-delivery-slot[data-shipment-id="${shipmentId}"]`);
                const url = deliverySlots?.attr("data-delivery-slot-url");
                $.spinner().start();

                $.ajax({
                    url: url,
                    type: "GET",
                    dataType: "JSON",
                    data: {
                        moreDaysToGet: true,
                        shipmentId: shipmentId,
                    },
                    success: response => {
                        var isResponseSuccess = !response.error && response.shipmentDeliverySlots && response.shipmentDeliverySlots.groupedDeliverySlots && response.shipmentDeliverySlots.groupedDeliverySlots.length > 0;
                        if (isResponseSuccess) {
                            const deliverySlot = document.querySelector(`.shipping-delivery-slot[data-shipment-id="${shipmentId}"]`);
                            let deliverySlotContainer = deliverySlot.querySelector(".js-delivery-slots-wrapper");
                            if (!deliverySlotContainer) {
                                deliverySlot.innerHTML = "<div class=\"js-delivery-slots-wrapper\"></div>";
                                deliverySlotContainer = deliverySlot.querySelector(".js-delivery-slots-wrapper");
                            }

                            initVueDeliverySchedule(deliverySlotContainer, response, true);
                            editStepHandler();
                            resolve();
                        } else {
                            const $deliverySlotsServiceErrorModal = $("#service-error-delivery-slots");

                            $deliverySlotsServiceErrorModal.modal("show");
                            reject(new Error("Couldn't get more delivery slots"));
                        }
                    },
                    error: function (err) {
                        reject(err);
                    },
                    complete: function () {
                        $.spinner().stop();
                    }
                });
            });
        },
        getLastArrowFromSlider() {
            this.offsetParent === null;
        },
        async handleBeforeSlide(currentSlide, nextSlide) {
            if (this.loadingMoreSlots) {
                return;
            }

            const slideLoadThresholds = {
                mobile: 3,
                tablet: 2,
                desktop: 1
            };
            const slideLoadThreshold = window.mqRespond.status.mobile
                ? slideLoadThresholds.mobile
                : window.mqRespond.status.tablet
                    ? slideLoadThresholds.tablet
                    : slideLoadThresholds.desktop;

            if (nextSlide >= slideLoadThreshold) {
                this.loadingMoreSlots = true;
                await this.getMoreShippingDays();
            }
        },
        getSchedulerIdsForDateItem(deliverySlot) {
            const schedulerIds = [];
            if (deliverySlot.slotDetails) {
                deliverySlot.slotDetails.forEach(slotDetails => {
                    schedulerIds.push(slotDetails.shippingSlotSchedulerId);
                });
            }

            return schedulerIds;
        },
        selectDefaultDay() {
            const isDisableAutomaticSlotting = document.querySelector("#disable-automatic-slotting")?.value === "true";

            this.currentShipmentContainer.querySelectorAll(".delivery-schedule-date").forEach(item => {
                if (!item.classList.contains("non-scheduled-delivery")) {
                    const target = item.querySelector(".delivery-schedule-date-item input.js-preselected-day") || (!isDisableAutomaticSlotting ? item.querySelector(".delivery-schedule-date-item input") : null);

                    if (!target) return;
                    
                    const shipmentID = target.getAttribute("data-shipment-id");
                    const currentShippingStatus = this.getShipmentData(shipmentID);
                    const targetWeekdayShort = target.getAttribute("data-weekday-short");
                    const targetDay = target.getAttribute("data-day");
                    const targetMonth = target.getAttribute("data-month");

                    currentShippingStatus.chosenWeekdayShort = targetWeekdayShort;
                    currentShippingStatus.chosenDay = targetDay;
                    currentShippingStatus.chosenMonth = targetMonth;

                    store.commit("setShipmentData", currentShippingStatus);
                    target.click();
                }
            });
        },
        getPreviouslyBookedDay() {
            const previouslyBookedSlots = document.querySelector("[data-previously-booked-delivery-slots]")?.dataset.previouslyBookedDeliverySlots.split(",");
            if (!previouslyBookedSlots || previouslyBookedSlots == null || previouslyBookedSlots === "null") { return; }
            this.currentShipmentContainer.querySelectorAll(".delivery-schedule-date-item").forEach(elem => {
                const schedulerIds = elem.dataset.intervalsSchedulerIds.split(",");
                schedulerIds.forEach(id => {
                    if (previouslyBookedSlots.includes(id) && !elem.querySelector("input").classList.contains("selected")) {
                        elem.querySelector("input").classList.add("js-preselected-day");

                        if (this.loadingMoreSlots === true) {
                            this.currentShipmentContainer.querySelectorAll(".delivery-schedule-interval-list [data-shipping-slot-scheduler-id]").forEach((e, index) => {
                                if (previouslyBookedSlots.includes(e.dataset.shippingSlotSchedulerId) &&
                                    !e.parentElement.classList.contains("selected")) {
                                    e.parentElement.classList.add("selected");
                                    if (index >= 2) {
                                        this.currentShipmentContainer.querySelector(".toggle-interval-list")?.click();
                                    }
                                }
                            });
                        }
                    }
                });
            });
        },
        setPreselectedNonScheduledDayActive() {
            const previouslyBookedSlots = document.querySelector("[data-previously-booked-delivery-slots]")?.dataset.previouslyBookedDeliverySlots.split(",");
            if (!previouslyBookedSlots || previouslyBookedSlots == null || previouslyBookedSlots === "null") { return; }
            this.currentShipmentContainer.querySelectorAll(".non-scheduled-delivery").forEach(nonScheduledDelivery => {
                nonScheduledDelivery.querySelectorAll("[data-shipping-slot-scheduler-id]").forEach(elem => {
                    if (previouslyBookedSlots.includes(elem.dataset.shippingSlotSchedulerId) &&
                        !elem.parentElement.classList.contains("selected") &&
                        !elem.parentElement.classList.contains("selected-non-scheduled"))
                    {
                        elem.click();
                    }
                });
            });

        },
    },
    components: {
        DeliveryScheduleDateItem,
        DeliveryScheduleIntervalList,
        DeliveryScheduleSummary,
        DeliveryNonScheduledSummary,
        VueSlickCarousel
    }
});

export default DeliveryScheduleComponent;
